<template>
  <div class="detail">
    <!-- <div class="banner">
      <img :src="banner.titleUrl" alt />
    </div>
    <div class="navBox">
      <div class="nav">
        <div class="title">{{ banner.title }}</div>
        <div class="about">
          <span class="author">作者：{{ banner.author }}</span>
          <span class="time">{{ banner.createTime }}</span>
        </div>
      </div>
    </div>
    <div class="contentBox">
      <div class="content">
        <div class="information" v-html="banner.content"></div>
      </div>
    </div>
    <div class="footer" style="margin-top: 60px"></div> -->

    <div v-html="notice.noticeContent" class="notice"></div>
  </div>
</template>

<script>
import { getNotice } from "@/api/system/articles";
export default {
  name: "notice",
  data() {
    return {
      notice: {},
      id: 1,
    };
  },
  created() {
    this.getNotice();
  },
  updated() {
    window.scroll(0, 0);
  },

  methods: {
    getNotice() {
      getNotice(this.id).then((res) => {
        this.notice = res.data;
      });
    },
  },
};
</script>

<style lang="scss">
.detail {
  .mind_top {
    background: #577eff !important;
    z-index: 99;
  }
  .navBox {
    display: flex;
    justify-content: center;
    .nav {
      width: 90%;
      display: flex;
      flex-direction: column;
      background: #fff;
      box-shadow: 0 10px 10px rgb(227, 245, 253);
      margin-top: -65px;
      border-radius: 8px;
      .title {
        font-size: 15px;
        color: #333;
        font-weight: 600;
        margin: 15px;
      }
      .about {
        margin: 0px 15px 15px;
        .time {
          margin: 0 20px;
        }
      }
    }
  }
  .contentBox {
    display: flex;
    justify-content: center;
    .content {
      width: 90%;
      display: flex;
      flex-direction: column;
      margin-top: 25px;
      line-height: 25px;
    }
  }
  .notice {
    width: 90%;
    margin: 10px auto;
    padding: 5px 3px;
    box-shadow: 0 10px 10px rgb(227, 245, 253);
    img {
      max-width: 100%;
    }
  }
  .banner {
    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>